import WeatherDashboard from './WeatherDashboard';

export default WeatherDashboard;
